import React from 'react';
import { getStaticContent } from '../constants/staticContent';

const DownloadsSection = ({ language = 'en', onNavigate }) => {
  const { DOWNLOADS_CONTENT } = getStaticContent(language);
  const handleDownloadClick = (link) => {
    if (link === 'preset') {
      onNavigate('services');
    } else if (link.startsWith('http')) {
      window.open(link, '_blank');
    } else if (link.endsWith('.pdf') || link.endsWith('.apk')) {
      // Handle file downloads (PDF, APK)
      const a = document.createElement('a');
      a.href = link;
      a.download = link.endsWith('.pdf') ? 'CropShield-User-Guide.pdf' : 'CropShield.apk';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  return (
    <section id="downloads" className="min-h-screen flex items-center bg-slate-50 py-20 px-4 md:px-8 border-t border-gray-100">
      <div className="max-w-7xl mx-auto w-full">
        {/* Header */}
        <div className="text-center mb-16 md:mb-20">
          <div className="inline-block mb-4">
            <span
              className="text-xs font-bold tracking-widest uppercase text-emerald-700 bg-emerald-50 px-4 py-1.5 rounded-full border border-emerald-200"
            >
              {DOWNLOADS_CONTENT.sectionLabel}
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            {DOWNLOADS_CONTENT.sectionTitle}
          </h2>
          <p className="text-base md:text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto">
            {DOWNLOADS_CONTENT.description}
          </p>
        </div>

        {/* Download Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-16">
          {DOWNLOADS_CONTENT.downloads.map((download, index) => (
            <div
              key={index}
              className="bg-white p-8 md:p-10 transition-all duration-300 transform"
              style={{
                borderRadius: '16px',
                border: '1px solid rgba(0,0,0,0.06)',
                boxShadow: '0 2px 12px rgba(0,0,0,0.07)'
              }}
              onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = '#F0FDF4';
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 28px rgba(0,0,0,0.12)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = '#FFFFFF';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,0,0,0.07)';
              }}
            >
              {/* Icon */}
              <div className="mb-6 w-12 h-12 md:w-16 md:h-16 mx-auto flex items-center justify-center">
                <download.icon className="text-emerald-600 w-10 h-10 md:w-12 md:h-12" />
              </div>
              
              {/* Title */}
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 text-center">
                {download.title}
              </h3>
              
              {/* Description */}
              <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-8 text-center">
                {download.description}
              </p>
              
              {/* Button */}
              <button
                onClick={() => handleDownloadClick(download.link)}
                className="w-full px-6 py-3.5 bg-emerald-600 text-white font-bold hover:bg-emerald-700 transition-colors duration-200 text-sm md:text-base"
                style={{ borderRadius: '8px' }}
              >
                {download.buttonText}
              </button>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div
          className="bg-white p-8 md:p-10 max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-8"
          style={{
            borderRadius: '16px',
            border: '1px solid rgba(0,0,0,0.06)',
            boxShadow: '0 2px 12px rgba(0,0,0,0.07)'
          }}
        >
          <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center text-3xl md:text-4xl">💡</div>
          <div className="flex-1 text-center md:text-left">
            <h4 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
              {DOWNLOADS_CONTENT.helpTitle}
            </h4>
            <p className="text-sm md:text-base text-gray-600 leading-relaxed">
              {DOWNLOADS_CONTENT.helpDescription}
            </p>
          </div>
          <a
            href="#footer"
            className="px-6 py-3.5 bg-gray-50 text-emerald-700 font-bold hover:bg-emerald-50 transition-colors duration-200 text-sm md:text-base whitespace-nowrap border border-gray-200"
            style={{ borderRadius: '8px' }}
          >
            {DOWNLOADS_CONTENT.contactSupport}
          </a>
        </div>
      </div>
    </section>
  );
};

export default DownloadsSection;
